import apiFetch from '../apiFetch'

export default function (token, includeDeleted = false) {
  return apiFetch({ endPoint: 'purchaseOrderType?includeDeleted=' + includeDeleted, method: 'GET', body: null, token: token })
}
